interface TableData {
  rowname: string[];
  contents: content[];
}

interface content {
  row1: any;
  row2: any;
  row3: any;
}

const Table = ({ tableData }: { tableData: TableData }) => {
  return (
    <table className="w-full mx-auto bg-white dark:bg-gray-900 rounded-lg overflow-hidden shadow-lg mb-6">
      <thead className="bg-gray-50 dark:bg-gray-700">
        <tr>
          {tableData.rowname.map((data, index) => (
            <th
              key={index}
              scope="col"
              className="px-3 py-1 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
            >
              {data}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-900">
        {tableData.contents.map((data, index) => (
          <tr key={index}>
            <td className="px-6 py-3 whitespace-nowrap">
              <div className="text-sm text-gray-900 dark:text-gray-200">
                {data.row1}
              </div>
            </td>
            <td className="px-3 py-1 whitespace-nowrap">
              <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                {data.row2}
              </div>
            </td>
            <td className="px-3 py-1 whitespace-nowrap">
              <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                {data.row3}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
